import Animations from './partials/animations';
import Cards from './partials/cards';
import Menu from './partials/menu';
import Sliders from './partials/sliders';

export default class Main {

	constructor() {
		this.init();
	}

	init() {

		const body = document.querySelector('body');
		body.classList.add('ready');

		Animations.init();
		Cards.init();
		Menu.init();
		Sliders.init();
	}

}

const main = new Main();
